<template>
  <div class="search-container">
    <input
      type="text"
      class="form-control"
      v-model="searchQuery"
      placeholder="Buscar pacientes por Nombre, DNI o Codigo"
      @input="onInput"
      @keydown.down.prevent="navigateDown"
      @keydown.up.prevent="navigateUp"
      @keydown.enter.prevent="selectHighlighted"
      @keydown.esc="closeSuggestions"
      @focus="userFocus=true"
    >
    <ul v-if="showSuggestions" class="suggestions-list">
      <li>
        <small class="text-secondary">Total {{ total_results }} resultados</small>
      </li>
      <li
        v-for="(option, index) in options"
        :key="option.id"
        :class="{ highlighted: index === highlightedIndex }"
        @click="selectOption(option)"
        @mouseenter="highlightedIndex = index"
      >
        <span class="badge badge-info">{{  option.code }}</span> {{ option.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import { DentalClinicService } from "./service";

export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    placeholder: { default: "Buscar paciente por Nombre, DNI, Codigo" }
  },

  data: () => ({
    model: null,
    searchQuery: "",
    options: [],
    total_results: 0,
    debounceTimer: null,
    highlightedIndex: -1,
    userFocus: false,
  }),

  computed: {
    showSuggestions() {
      return this.userFocus && this.searchQuery && this.options && this.searchQuery.length > 0 && this.options.length > 0;
    }
  },

  watch: {
    //
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    handleClickOutside(e) {
      if (!e.target.closest(".search-container")) {
        this.highlightedIndex = -1;
        this.userFocus = false;
      }
    },
    afterSelect({ id }) {
      this.userFocus = false;
      this.$router.push(`/dental-clinic/patients/${id}`);
    },
    closeSuggestions() {
      this.highlightedIndex = -1;
    },
    navigateDown() {
      if (this.options && this.highlightedIndex < this.options.length - 1) {
        this.highlightedIndex++;
      }
    },
    navigateUp() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      }
    },
    selectHighlighted() {
      if (this.highlightedIndex >= 0 && this.options[this.highlightedIndex]) {
        this.selectOption(this.options[this.highlightedIndex]);
      }
    },
    selectOption(option) {
      this.afterSelect(option);
      this.highlightedIndex = -1;
    },
    onInput() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.makeSearch();
      }, 300);
    },
    async makeSearch() {
      let list = await this.search(this.searchQuery);
      this.options = list;
      this.highlightedIndex = -1;
    },
    async search(search) {
      var result = await DentalClinicService.getClients({ search });
      this.total_results = result.total;
      return result.data.map((x) => {
        var code = "";
        if (x.code) {
          code = x.code + " ";
        }
        x.full_name = `${code}${x.name}`;
        return x;
      });
    }
  }
};
</script>

<style scoped>
.min_long {
  min-width: 400px;
}
.search-container {
  position: relative;
  width: 100%;
}
.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
}
.suggestions-list li {
  padding: 10px;
  cursor: pointer;
}
.suggestions-list li.highlighted {
  background: #f0f0f0;
}
.suggestions-list li:hover {
  background: #f0f0f0;
}
</style>
